(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('MailTemplatesService', MailTemplatesService);

    MailTemplatesService.$inject = ['$rootScope', '$http', 'Principal'];

    function MailTemplatesService($rootScope, $http, Principal) {
        var service = {
            checkUnique: checkUnique,
            getTemplatesByType: getTemplatesByType,
            download: download,
            addTemplateTitle: addTemplateTitle,
            getAllTemplates: getAllTemplates
        };

        return service;

        function checkUnique(name, actionType, language, type) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxTemplates/isTemplateUnique',
                params: { 'name': name, 'actionType': actionType, 'language': language, 'type': type }
            });
        }

        function getTemplatesByType(type) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/' + Principal.getCurrentEntityLowerCase() + 'Templates/search/findByType',
                params: { 'type': type, 'size': 10 }
            });
        }

        function download(name, actionType, language) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxTemplates/download',
                params: { 'name': name, 'actionType': actionType, 'language': language },
                responseType: 'arraybuffer'
            });
        }

        function addTemplateTitle(name, actionType, text, language) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxTemplates/add',
                params: { 'name': name, 'actionType': actionType, 'text': text, 'language': language, 'type': 'EMAIL_TITLE' }
            });
        }

        function getAllTemplates() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/' + Principal.getCurrentEntityLowerCase() + 'Templates/search/findAllBy'
            });
        }

    }
})();
